import { Stack, Typography } from "@mui/material"
import type { PropsWithChildren, ReactNode } from "react"

interface SectionTitleProps extends PropsWithChildren<any> {
  title: string
  startIcon?: JSX.Element
  endIcon?: JSX.Element
  subtitle?: ReactNode
}

const SectionTitle = ({
  title,
  startIcon,
  endIcon,
  children,
  subtitle,
}: SectionTitleProps) => {
  return (
    <Stack
      direction={"row"}
      alignItems={"flex-start"}
      gap={1}
      sx={{ minWidth: 0, flex: 1 }}
    >
      {startIcon}
      <Stack direction="column" gap={1} sx={{ minWidth: 0, flex: 1 }}>
        <Stack
          direction="row"
          alignItems="center"
          spacing={0.75}
          flexWrap="wrap"
          overflow="hidden"
        >
          <Typography
            variant="h5"
            title={title}
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {title}
          </Typography>
          {children}
          {endIcon}
        </Stack>
        {subtitle}
      </Stack>
    </Stack>
  )
}

export default SectionTitle
